<template>
  <fragment>
    <mc-app-header title="Admin Dashboard Users">
      <template #right>
        <div class="level-item">
          <b-field>
            <b-input
              v-model="kw"
              icon="magnify"
              placeholder="Search by Email"
              type="search"
            />
          </b-field>
        </div>
      </template>
    </mc-app-header>
    <mc-app-body>
      <b-loading v-if="admin.loading" active :is-full-page="false" />
      <mc-error-layout
        v-else-if="admin.loadError"
        message="Failed to load users!"
        :retry-fn="load"
      />
      <div v-else class="admin section">
        <b-table
          bordered
          :data="admin.users"
          hoverable
          striped
          @click="selectedUser = $event"
        >
          <template #default="{ row }">
            <b-table-column field="displayName" label="Name">{{
              row.displayName || row.guardianName || 'N.A'
            }}</b-table-column>
            <b-table-column field="email" label="Email">{{
              row.email || 'N.A'
            }}</b-table-column>
            <b-table-column field="roles" label="Roles">
              <b-taglist v-if="row.roles && row.roles.length > 0">
                <b-tag
                  v-for="(role, index) in row.roles"
                  :key="index"
                  type="is-info"
                  >{{ startCase(role) }}</b-tag
                >
              </b-taglist>
              <p v-else class="admin__no-roles">No roles assigned</p>
            </b-table-column>
          </template>
          <template #empty>
            <div class="content has-text-centered">No users found!</div>
          </template>
        </b-table>
      </div>
      <assign-roles-modal :user="selectedUser" :on-close="closeModalHandler" />
    </mc-app-body>
  </fragment>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import debounce from 'lodash/debounce';
import startCase from 'lodash/startCase';

import AssignRolesModal from './AssignRolesModal';

export default {
  data: function() {
    return {
      kw: '',
      selectedUser: null
    };
  },
  computed: {
    ...mapState(['admin'])
  },
  methods: {
    ...mapActions('admin', ['getAdminUsers', 'getSearchedUsers']),
    closeModalHandler() {
      this.selectedUser = null;
    },
    load() {
      if (this.kw) this.getSearchedUsers(this.kw);
      else this.getAdminUsers();
    },
    startCase: startCase
  },
  watch: {
    kw: debounce(function() {
      this.load();
    }, 300)
  },
  created() {
    this.load();
  },
  components: {
    AssignRolesModal
  }
};
</script>

<style lang="scss" scoped>
.admin {
  /deep/ tbody {
    tr {
      cursor: pointer;
    }
  }

  &__no-roles {
    margin-bottom: 0.5rem;
  }
}
</style>
